var oneId = function () {
  return Number(Math.floor(Math.random()*36)).toString(36);
};

var createRequestId = function () {
  var head = Number(new Date().valueOf()).toString(36);
  return head + oneId() + oneId() + oneId() + oneId() + oneId() + oneId();
};

module.exports = createRequestId;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.messageCenter/lib/requestid.js